module.exports = __webpack_public_path__ + "static/img/img010.4276257.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/img010.jpg
// module id = w7ip
// module chunks = 0